import { render, staticRenderFns } from "./viaspago.vue?vue&type=template&id=b3558fd4"
import script from "./viaspago.vue?vue&type=script&lang=js"
export * from "./viaspago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports